<template>
  <v-autocomplete
    :label="title"
    hide-details="auto"
    :value="value"
    :items="country"
    :item-text="`countryFullText`"
    :disabled="disabled"
    item-value="countryID"
    outlined
    dense
    @change="onEmit"
  >
    <template v-slot:selection="{ item }">
      <div class="py-2">
        <span class="px-1">
          <v-chip>
            {{ item.countryID }}
          </v-chip>
        </span>
        <span class="subtitle px-1">
          {{ item.countryNameEng }}
        </span>
        <span class="subtitle grey--text px-1">
          <small>
            {{ item.countryNameTha }}
          </small>
        </span>
      </div>
    </template>

    <template v-slot:item="{ item }">
      <div class="pa-2">
        <span class="px-1">
          <v-chip>
            {{ item.countryID }}
          </v-chip>
        </span>
        <span class="subtitle px-1">
          {{ item.countryNameEng }}
        </span>
        <span class="subtitle grey--text px-1">
          <small>
            {{ item.countryNameTha }}
          </small>
        </span>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'ประเทศ'
    },
    value: {
      type: String,
      default: ''
    },

    filter: {
      type: [String, Array],
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    excludes: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      countryOrigin: [],
      country: []
    }
  },

  watch: {
    excludes: {
      deep: true,
      handler() {
        this.country = this.countryOrigin.filter(item => {
          return !this.excludes.includes(item.countryID)
        })
        if (this.excludes.includes(this.value)) {
          this.$emit('input', this.country[0].countryID)
        }
      }
    }
  },

  async mounted() {
    this.country = await this.apiGetCountry()
    this.countryOrigin = JSON.parse(JSON.stringify(this.country))
  },

  methods: {
    onEmit(country) {
      const item = this.country.find(item => item.countryID === country)

      let res = null
      if (typeof this.filter === 'string') {
        res = item[this.filter] ? item[this.filter] : ''
      } else if (Array.isArray(this.filter)) {
        res = {}
        for (let index in this.filter) {
          res[this.filter[index]] = item[this.filter[index]]
            ? item[this.filter[index]]
            : ''
        }
      } else {
        res = item
      }
      this.$emit('input', res)
    },

    async apiGetCountry() {
      this.loading = true
      const action = 'reference/getCountry'

      try {
        const res = await this.$store.dispatch(action)
        if (res.data?.data) {
          return res.data.data.map(item => {
            item.countryFullText =
              item.countryID +
              item.countryNameEng +
              item.countryNameTha +
              item.countryShortName
            return item
          })
        }
        return res.data?.data || []
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
